import { render, staticRenderFns } from "./MessageBox.vue?vue&type=template&id=372fa5a0&"
import script from "./MessageBox.vue?vue&type=script&lang=ts&"
export * from "./MessageBox.vue?vue&type=script&lang=ts&"
import style0 from "./MessageBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports